import React, {Component} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import api from '../../services/api';
import ReactHtmlParser from 'react-html-parser';
import Container from 'react-bootstrap/esm/Container';
import Logorodape from '../Logomarca/logorodape';
import Logo100anos from '../Logomarca/logo100anos';

export default class Contacts extends Component{
   // executa após o componente ser ativado
   componentDidMount (){
      this.loadDados();
   }
   
   // carrega os dados da api... promisse
   loadDados = async () =>{
      const {data} = await api.get('/contato');
      this.setState({ dados: data });
   }
   
   // armazena os dados no estado
   state = {
      dados: [],  
   }
   
      // renderiza o componente 
   render(){
      return ( 
         <div>
            {/* percorre o array de dados e exibe */}
            { this.state.dados.map ( dado => (
               <div key = { dado.id }> 
                  <Container id="">
                     <Row className="py-5" id="contact">
                        <Col xs={12} sm={4} >
                           <div className="mb-sm-0 mb-4">
                           <Logorodape />
                           <Logo100anos />                           
                           </div>
                        </Col>
                        <Col sm={4}>
                              <p><b>Endereço</b>
                                 <br />
                                    { ReactHtmlParser(dado.endereco)}                              
                              </p>
                              <p><b>Telefone</b>
                                 <br />
                                 { ReactHtmlParser(dado.telefone)}                              
                              </p>                              
                              <p><b>E-mail</b>
                                 <br />
                                 { ReactHtmlParser(dado.email)}
                              </p>
                        </Col>
                        <Col sm={4}>
                              { ReactHtmlParser(dado.localizacao)}
                        </Col>
                     </Row>
                  </Container>
               </div>             
            )) }                        
         </div>

      )
   }
}